export interface IcommonStateAction {
    type: string;
    value: any;
}

export const getMenuCode = () => ({
    type: 'GET_MENU_CODE',
    value: '',
});

export const getScreenType = () => ({
    type: 'GET_SCREEN_TYPE',
    value: '',
});

export const changeCompanyMetaData = (data: any) => ({
    type: 'CHANGE_COMPANY_METADATA',
    value: data,
});

export const changeSwitchPageData = (data: any) => ({
    type: 'CHANGE_SWITCH_PAGE_DATA',
    value: data,
});

export const showRightPaneState = (data: boolean) => ({
    type: 'SHOW_RIGHT_PANE_STATE',
    value: data,
});

export const menuPaneStatus = (data: string) => ({
    type: 'MENU_PANE_STATUS_DATA',
    value: data,
});

export const offTheCuffTitle = (data: string) => ({
    type: 'OFF_THE_CUFF_TITLE',
    value: data,
});

export const currentAuthorID = (data: string) => ({
    type: 'CURRENT_AUTHOR_ID',
    value: data,
});

export const currentAuthorName = (data: string) => ({
    type: 'CURRENT_AUTHOR_NAME',
    value: data,
});

export const updateHealthWarningWidth = (data: number) => ({
    type: 'UPDATE_HEALTH_WARNING_WIDTH',
    value: data,
});

export const htmlPDFtoggleStatus = (data: boolean) => ({
    type: 'HTML_PDF_TOGGLE_STATUS',
    value: data,
});

export const updateFinancialsContentTabTitle = (data: number) => ({
    type: 'UPDATE_FINANCIALS_CONTENT_TAB_TITLE',
    value: data,
});

export const frontpageloaded = (data: boolean) => ({
    type: 'FRONT_PAGE_LOADED',
    value: data,
});

export const fetchBodyJsonFinished = (data: boolean) => ({
    type: 'FETCH_BODY_JSON_FINISHED',
    value: data,
});

export const updateCompanyCoverageAndDerivedFields = (data: any) => ({
    type: 'COMPANY_COVERAGE_AND_DERIVED_FIELDS',
    value: data,
});
